"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isResponseType = isResponseType;

function isResponseType(response) {
  var _error;

  return Boolean(response.errorMessage || ((_error = response.error) === null || _error === void 0 ? void 0 : _error.message));
}